export const ADMINISTRATION_TAB_KEYS = {
  OSOS_LIST: "osos-list",
  BILLINGS: "billings",
  USERS: "users",
  AUDIT_TABLE: "audit-table",
};

export const USER_ROLES_COLORS = {
  admin: "secondary",
  guest: "neutral",
  supervisor: "info",
} as const;

export const USER_STATUSES_COLORS = {
  invited: "info",
  confirmed: "primary",
} as const;
